<template>
  <div class="modal-login">
    <div class="login-sidebar">
      <img src="@/assets/img/logo_small.png" />
      <div class="sidebar-text">
        <span class="gradient-green">
          WELCOME TO THE MOST INNOVATIVE CS:GO CASINO
        </span>
      </div>
      <img
        v-if="modalTab === 'register'"
        class="csgs-image2"
        src="@/assets/img/csgs2.png"
      />
      <img
        v-if="['login', 'roblox login'].includes(modalTab)"
        class="csgs-image"
        src="@/assets/img/csgs.png"
      />
    </div>
    <div class="login-content">
      <div class="content-title">
        <span class="gradient-green">
          {{
            modalTab === "forgot" ? "RESET PASSWORD" : modalTab.toUpperCase()
          }}
        </span>
      </div>
      <div
        v-if="['login', 'register', 'roblox login', 'roblox cookie'].includes(modalTab)"
        class="content-auth"
      >
        <LoginRoblox
          v-if="['roblox login', 'roblox cookie'].includes(modalTab)"
          :tab="modalTab"
        />
        <LoginCredentials v-else :tab="modalTab" />

        <div class="auth-seperator">OR SIGN IN USING</div>
        <button
          v-if="['roblox login', 'roblox cookie'].includes(modalTab)"
          @click="modalSetTab('login')"
          class="button-credentials"
        >
          <div class="button-inner">Sign in with Email</div>
        </button>
        <button @click="loginWithSteam" class="button-roblox">
          <div class="button-inner">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              role="img"
              fill="currentColor"
            >
              <title>Steam Icon</title>
              <path d="M11.979 0C5.678 0 .511 4.86.022 11.037l6.432 2.658c.545-.371 1.203-.59 1.912-.59.063 0 .125.004.188.006l2.861-4.142V8.91c0-2.495 2.028-4.524 4.524-4.524 2.494 0 4.524 2.031 4.524 4.527s-2.03 4.525-4.524 4.525h-.105l-4.076 2.911c0 .052.004.105.004.159 0 1.875-1.515 3.396-3.39 3.396-1.635 0-3.016-1.173-3.331-2.727L.436 15.27C1.862 20.307 6.486 24 11.979 24c6.627 0 11.999-5.373 11.999-12S18.605 0 11.979 0zM7.54 18.21l-1.473-.61c.262.543.714.999 1.314 1.25 1.297.539 2.793-.076 3.332-1.375.263-.63.264-1.319.005-1.949s-.75-1.121-1.377-1.383c-.624-.26-1.29-.249-1.878-.03l1.523.63c.956.4 1.409 1.5 1.009 2.455-.397.957-1.497 1.41-2.454 1.012H7.54zm11.415-9.303c0-1.662-1.353-3.015-3.015-3.015-1.665 0-3.015 1.353-3.015 3.015 0 1.665 1.35 3.015 3.015 3.015 1.663 0 3.015-1.35 3.015-3.015zm-5.273-.005c0-1.252 1.013-2.266 2.265-2.266 1.249 0 2.266 1.014 2.266 2.266 0 1.251-1.017 2.265-2.266 2.265-1.253 0-2.265-1.014-2.265-2.265z" />
            </svg>
            Sign in with Steam
          </div>
        </button>
        <!-- Additional Google Login Button -->
        <button @click="loginWithGoogle" class="button-google">
          <div class="button-inner">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="currentColor" d="M3.064 7.51A10 10 0 0 1 12 2c2.695 0 4.959.991 6.69 2.605l-2.867 2.868C14.786 6.482 13.468 5.977 12 5.977c-2.605 0-4.81 1.76-5.595 4.123c-.2.6-.314 1.24-.314 1.9s.114 1.3.314 1.9c.786 2.364 2.99 4.123 5.595 4.123c1.345 0 2.49-.355 3.386-.955a4.6 4.6 0 0 0 1.996-3.018H12v-3.868h9.418c.118.654.182 1.336.182 2.045c0 3.046-1.09 5.61-2.982 7.35C16.964 21.105 14.7 22 12 22A9.996 9.996 0 0 1 2 12c0-1.614.386-3.14 1.064-4.49"/></svg>
            Sign in with Google
          </div>
        </button>
      </div>
      <LoginForgot v-else />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import LoginCredentials from "@/components/login/LoginCredentials"
import LoginRoblox from "@/components/login/LoginRoblox"
import LoginForgot from "@/components/login/LoginForgot"

export default {
  name: "ModalLogin",
  components: {
    LoginCredentials,
    LoginRoblox,
    LoginForgot,
  },
  data() {
    return {
      modalTab: "login", // default tab is 'login'
    }
  },
  methods: {
    ...mapActions(["modalsSetShow"]),
    modalSetTab(tab) {
      this.modalTab = tab // Set the tab dynamically
    },
    modalTermsButton() {
      this.modalsSetShow(null)
      setTimeout(() => {
        this.modalsSetShow("Terms")
      }, 300)
    },
    loginWithSteam() {
      const authUrl = `${process.env.VUE_APP_BACKEND_URL}/auth/steam`
      window.location.href = authUrl
    },
    loginWithGoogle() {
      // Implement Google login logic here
      console.log("Google Login triggered!")
    },
  },
}
</script>


<style scoped>
.modal-login {
  width: 1010px;
  border-radius: 15px;
  background: radial-gradient(
      100% 100% at 50% -31.45%,
      rgba(0, 255, 194, 0.2) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    linear-gradient(255deg, #07263d 0%, #07243a 100%);
}

.modal-login .login-sidebar {
  width: 237px;
  height: 100%;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 0;
  left: 0;
  border-radius: 15px 0 0 15px;
  background: radial-gradient(
      225% 75% at 50% 50%,
      rgba(21, 71, 98, 0.2) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    #051e2e;
}

.modal-login .login-sidebar img:nth-of-type(1) {
  width: 143px;
  margin-top: 45px;
}

.csgs-image {
  top: 526px;
}

.csgs-image2 {
  top: 600px;
}

.modal-login .login-sidebar img:nth-of-type(2) {
  position: absolute;
  bottom: -45px;
}

.modal-login .sidebar-text {
  width: 100%;
  position: relative;
  margin-top: 42px;
  padding: 15px 30px;
  text-align: center;
  background: linear-gradient(
    255deg,
    rgba(0, 255, 194, 0.05) 0%,
    rgba(0, 170, 109, 0.05) 100%
  );
}

.modal-login .sidebar-text::before {
  content: "";
  width: 100%;
  height: 1px;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(
      255deg,
      rgba(0, 255, 194, 0.5) 0%,
      rgba(0, 170, 109, 0.5) 100%
    ),
    #18486d;
}

.modal-login .sidebar-text::after {
  content: "";
  width: 100%;
  height: 1px;
  position: absolute;
  bottom: 0;
  left: 0;
  background: linear-gradient(
      255deg,
      rgba(0, 255, 194, 0.5) 0%,
      rgba(0, 170, 109, 0.5) 100%
    ),
    #18486d;
}

.modal-login .sidebar-text span {
  font-family: "Rubik";
  line-height: 28px;
  font-size: 18px;
  font-weight: 900;
  text-shadow: 0px 0px 50px rgba(0, 255, 194, 0.25);
}

.modal-login .login-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 35px 110px 48px 347px;
}

.modal-login .content-title {
  text-align: center;
  font-size: 32px;
  font-weight: 900;
}

.modal-login .content-auth {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 35px;
}

.modal-login .auth-seperator {
  width: 530px;
  position: relative;
  margin-top: 35px;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #5e768e;
}

.modal-login .auth-seperator:before,
.modal-login .auth-seperator:after {
  content: "";
  width: calc(50% - 110px);
  height: 1px;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  background: #18486d;
  opacity: 0.5;
}

.modal-login .auth-seperator:before {
  left: 0;
}

.modal-login .auth-seperator:after {
  right: 0;
}

.modal-login button.button-credentials,
.modal-login button.button-roblox,
.modal-login button.button-google {

  width: 100%;
  height: 54px;
  margin-top: 35px;
}

.modal-login button.button-credentials .button-inner,
.modal-login button.button-roblox .button-inner,
.modal-login button.button-google .button-inner {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
  background: #1a4f63;
  clip-path: polygon(
    11px 0,
    calc(100% - 11px) 0,
    100% 25%,
    100% 75%,
    calc(100% - 11px) 100%,
    11px 100%,
    0 75%,
    0 25%
  );
}

.modal-login button.button-roblox .button-inner {
  background: linear-gradient(90deg, #1b2838 40%, #171a21 100%); /* Steam-like gradient */
}

.modal-login button.button-google .button-inner {
  background: linear-gradient(90deg, #FFB100 0%, #FF7043 100%); /* Google orange gradient */
}


.modal-login button.button-roblox .button-inner svg {
  margin-right: 14px;
  fill: #ffffff;
}

.modal-login button.button-google .button-inner svg {
  margin-right: 14px;
  fill: #ffffff;
}

@media only screen and (max-width: 1030px) {
  .modal-login {
    width: calc(100vw - 20px);
  }
}

@media only screen and (max-width: 950px) {
  .modal-login .login-sidebar {
    display: none;
  }

  .modal-login .login-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 85px 15px 48px 15px;
  }
}

@media only screen and (max-width: 560px) {
  .modal-login .auth-seperator {
    width: 100%;
  }
}
</style>
